import { Box, Stack, useMediaQuery, useTheme } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { H8 } from '../../components/Typography';
import FlexBox from '../../components/flexbox/FlexBox';

const CommunityCategoryBox = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  const [searchParams] = useSearchParams();

  // Get current category from URL parameters
  const currentCategory = searchParams.get('category') || 'all';

  // Category dataset with icons and subcategories
  const categoryData = [
    {
      id: 'all',
      title: '전체',
      icon: '/static/icons/all.png',
      route: '/naver/callmetellme/community/category-list?category=all',
    },
    {
      id: 'best',
      title: '베스트',
      icon: '/static/icons/best.png',
      route: '/naver/callmetellme/community/category-list?category=best',
      subcategories: [
        {
          id: 'best-general',
          title: '일반',
          route:
            '/naver/callmetellme/community/category-list?category=best-general',
        },
      ],
    },
    {
      id: 'gossip',
      title: '뒷담화',
      icon: '/static/icons/bamboo.png',
      route: '/naver/callmetellme/community/category-list?category=gossip',
      subcategories: [
        {
          id: 'gossip-leehanseol',
          title: '이한솔',
          route:
            '/naver/callmetellme/community/category-list?category=gossip-leehanseol',
        },
        {
          id: 'gossip-kimchanseol',
          title: '김찬솔',
          route:
            '/naver/callmetellme/community/category-list?category=gossip-kimchanseol',
        },
      ],
    },
    {
      id: 'info',
      title: '꿀정보',
      icon: '/static/icons/honey.png',
      route: '/naver/callmetellme/community/category-list?category=info',
      subcategories: [
        {
          id: 'info-super',
          title: '개꿀정보',
          route:
            '/naver/callmetellme/community/category-list?category=info-super',
        },
        {
          id: 'info-second',
          title: '2꿀정보',
          route:
            '/naver/callmetellme/community/category-list?category=info-second',
        },
      ],
    },
    {
      id: 'free',
      title: '자유게시판',
      icon: '/static/icons/chatbubble.png',
      route: '/naver/callmetellme/community/category-list?category=free',
      subcategories: [
        {
          id: 'free-general',
          title: '일반',
          route:
            '/naver/callmetellme/community/category-list?category=free-general',
        },
        {
          id: 'free-general2',
          title: '일반2',
          route:
            '/naver/callmetellme/community/category-list?category=free-general2',
        },
        {
          id: 'free-general3',
          title: '일반3',
          route:
            '/naver/callmetellme/community/category-list?category=free-general3',
        },
      ],
    },
    {
      id: 'qna',
      title: '질문답변',
      icon: '/static/icons/bamboo.png',
      route: '/naver/callmetellme/community/category-list?category=qna',
      subcategories: [
        {
          id: 'qna-general',
          title: '일반',
          route:
            '/naver/callmetellme/community/category-list?category=qna-general',
        },
        {
          id: 'qna-general2',
          title: '일반2',
          route:
            '/naver/callmetellme/community/category-list?category=qna-general2',
        },
        {
          id: 'qna-general3',
          title: '일반3',
          route:
            '/naver/callmetellme/community/category-list?category=qna-general3',
        },
        {
          id: 'qna-general4',
          title: '일반4',
          route:
            '/naver/callmetellme/community/category-list?category=qna-general4',
        },
      ],
    },
  ];

  return (
    <>
      {isTablet ? (
        // Tablet layout: Horizontal row with individual square boxes
        <Box
          sx={{
            display: 'flex',
            gap: '8px',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '16px',
            width: '100%',
            overflowX: 'auto',
            '&::-webkit-scrollbar': {
              display: 'none',
            },
            scrollbarWidth: 'none',
          }}
        >
          {categoryData.map(category => {
            const isActive = currentCategory === category.id;

            return (
              <Box
                key={category.id}
                onClick={() => navigate(category.route)}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  cursor: 'pointer',
                  flex: 1,
                  minWidth: '60px',
                  maxWidth: '100px',
                  transition: 'all 0.2s ease-in-out',
                  '&:hover': {
                    transform: 'translateY(-2px)',
                  },
                }}
              >
                {/* Square white box with icon */}
                <Box
                  sx={{
                    width: '100%',
                    aspectRatio: '1',
                    maxWidth: '58px',
                    backgroundColor: '#ffffff',
                    borderRadius: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
                    marginBottom: '8px',
                  }}
                >
                  <img
                    src={category.icon}
                    alt={`${category.title} icon`}
                    style={{
                      width: '70%',
                      height: '70%',
                      maxWidth: '32px',
                      maxHeight: '32px',
                    }}
                  />
                </Box>
                {/* Title below the box */}
                <H8
                  sx={{
                    color: isActive
                      ? theme.palette.primary.mainBlue
                      : theme.palette.primary.dark,
                    fontWeight: isActive ? 600 : 400,
                    fontSize: '12px',
                    textAlign: 'center',
                    lineHeight: 1.2,
                    wordBreak: 'keep-all',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    width: '100%',
                  }}
                >
                  {category.title}
                </H8>
              </Box>
            );
          })}
        </Box>
      ) : (
        // Desktop/Mobile layout: Vertical list in white box
        <Box
          sx={{
            backgroundColor: '#ffffff',
            borderRadius: '24px',
            padding: '16px 4px 16px 16px',
            boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
            border: '1px solid #f0f0f0',
            maxHeight: 'calc(100vh - 120px)',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {/* Fixed "All" Category */}
          <Box sx={{ mb: 0.5 }}>
            {(() => {
              const allCategory = categoryData[0];
              const isActive = currentCategory === allCategory.id;
              return (
                <FlexBox
                  onClick={() => navigate(allCategory.route)}
                  sx={{
                    alignItems: 'center',
                    cursor: 'pointer',
                    padding: '10px 10px',
                    borderRadius: '12px',
                    transition: 'all 0.2s ease-in-out',
                    backgroundColor: isActive ? '#f8fafc' : 'transparent',
                    '&:hover': {
                      backgroundColor: '#f1f5f9',
                    },
                  }}
                >
                  <img
                    src={allCategory.icon}
                    alt={`${allCategory.title} icon`}
                    style={{
                      width: '24px',
                      height: '24px',
                      marginRight: '12px',
                    }}
                  />
                  <H8
                    sx={{
                      color: isActive
                        ? theme.palette.primary.mainBlue
                        : theme.palette.primary.dark,
                      fontWeight: isActive ? 700 : 600,
                      fontSize: '16px',
                    }}
                  >
                    {allCategory.title}
                  </H8>
                </FlexBox>
              );
            })()}
          </Box>

          <Box
            sx={{
              overflowY: 'auto',
              flex: 1,
              paddingRight: '2px',
              '&::-webkit-scrollbar': {
                width: '4px',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#e0e0e0',
                borderRadius: '4px',
              },
              '&::-webkit-scrollbar-track': {
                backgroundColor: 'transparent',
              },
            }}
          >
            <Stack spacing={0.5}>
              {categoryData.slice(1).map(category => {
                const isActive = currentCategory === category.id;

                return (
                  <Box key={category.id}>
                    {/* Main Category */}
                    <FlexBox
                      onClick={() => navigate(category.route)}
                      sx={{
                        alignItems: 'center',
                        cursor: 'pointer',
                        padding: '10px 10px',
                        borderRadius: '12px',
                        transition: 'all 0.2s ease-in-out',
                        backgroundColor: isActive ? '#f8fafc' : 'transparent',
                        '&:hover': {
                          backgroundColor: '#f1f5f9',
                        },
                      }}
                    >
                      <img
                        src={category.icon}
                        alt={`${category.title} icon`}
                        style={{
                          width: '24px',
                          height: '24px',
                          marginRight: '12px',
                        }}
                      />
                      <H8
                        sx={{
                          color: isActive
                            ? theme.palette.primary.mainBlue
                            : theme.palette.primary.dark,
                          fontWeight: isActive ? 700 : 600,
                          fontSize: '16px',
                        }}
                      >
                        {category.title}
                      </H8>
                    </FlexBox>

                    {/* Subcategories */}
                    {category.subcategories &&
                      category.subcategories.length > 0 && (
                        <Stack spacing={0.5} sx={{ mt: 0.5 }}>
                          {category.subcategories.map(subcategory => {
                            const isSubActive =
                              currentCategory === subcategory.id;

                            return (
                              <FlexBox
                                key={subcategory.id}
                                onClick={() => navigate(subcategory.route)}
                                sx={{
                                  alignItems: 'center',
                                  cursor: 'pointer',
                                  padding: '8px 10px 8px 46px',
                                  borderRadius: '8px',
                                  transition: 'all 0.2s ease-in-out',
                                  backgroundColor: isSubActive
                                    ? '#f8fafc'
                                    : 'transparent',
                                  '&:hover': {
                                    backgroundColor: '#f1f5f9',
                                  },
                                }}
                              >
                                <H8
                                  sx={{
                                    color: isSubActive
                                      ? theme.palette.primary.mainBlue
                                      : theme.palette.text.secondary,
                                    fontWeight: isSubActive ? 600 : 400,
                                    fontSize: '15px',
                                  }}
                                >
                                  {subcategory.title}
                                </H8>
                              </FlexBox>
                            );
                          })}
                        </Stack>
                      )}
                  </Box>
                );
              })}
            </Stack>
          </Box>
        </Box>
      )}
    </>
  );
};

export default CommunityCategoryBox;
